export default __webpack_public_path__ + "static/media/pic2.c6cd46b4.jpg";